
import {defineComponent} from 'vue'
import PimProductsOverviewItemIcons from "@/components/layouts/pim/PimProductsOverviewItemIcons.vue";
import {LaboProductOverviewRestDtoModel} from "@/models/api/pharma-pim-labo/LaboProductOverviewRestDtoModel";
import {AbilityContext} from "@/context/AbilityContext";

export default defineComponent({
  name: "PimProductsOverviewTilesItem",
  emits: ["openOffCanvasProductDetail"],
  components: {ItemIcons: PimProductsOverviewItemIcons},
  props: {
    product: {
      type: [LaboProductOverviewRestDtoModel, Object],
      required: true
    }
  },
  computed:{
    AbilityContext() {
      return AbilityContext
    },
  },
  methods: {
    openOffCanvasProductDetail(): void {
      if (AbilityContext.isAuthorizedForFeature('PIM_LABO_PRODUCT_INFO') && this.product.product_info.cnk_code){
        this.$emit("openOffCanvasProductDetail", this.product);
      }
    },
  }
})
